import { Component, Input, OnInit, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { AddPlanComponent } from '../plan-form/add-plan.component';
import { PlanService } from 'src/app/services/planService/plan.service';
import { Excedents } from 'src/app/models/plan';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-plans-table',
  templateUrl: './plans-table.component.html',
  styleUrls: ['./plans-table.component.scss']
})
export class PlansTableComponent implements OnInit, OnChanges {

  // Configuración para planes
  settingsPlans = {
    actions: {
      columnTitle: "Acciones",
      add: false,
      edit: true,
      delete: false,
      custom: [
        {
          name: 'toggle',
          title: '<span class="toggle-btn">Estado</span>'
        }
      ],
      position: "right",
    },
    pager: {
      display: true,
      perPage: 20,
    },
    add: {
      addButtonContent: "<span>Nuevo Plan</span>"
    },
    edit: {
      editButtonContent: "<span>Editar</span>",
    },
    delete: {
      deleteButtonContent: "<span>Eliminar</span>",
    },
    columns: {
      title: { title: "Plan" },
      precio: { title: "Precio", filter: false },
      time: { title: "Horas" },
      minutes: { title: "Minutos Llamadas" },
      active: {
        title: "Estado",
        type: "html",
        valuePrepareFunction: (value) => {
          return value
            ? '<span style="color: green; font-weight: bold;">Activo</span>'
            : '<span style="color: red; font-weight: bold;">Inactivo</span>';
        }
      }   
    },
    rowClassFunction: (row) => {
      return row.data.active ? 'row-active' : 'row-inactive';
    },
    mode: "external",
    noDataMessage: "No hay registros por ahora",
  };

  // Configuración para excedentes
  settingsExcedents = {
    actions: {
      columnTitle: "Acciones",
      add: false,
      edit: true,
      delete: false,
      position: "right",
    },
    pager: {
      display: true,
      perPage: 20,
    },
    edit: {
      editButtonContent: "<span>Editar</span>",
    },
    columns: {
      title: { title: "Bloque Excedente", filter: false },
      precio: { title: "Precio", filter: false },
      time: { title: "Horas", filter: false },
      timeCalls: { title: "Minutos Llamadas", filter: false },
    },
    mode: "external",
    noDataMessage: "No hay registros por ahora",
  };

  @Input() data_source_3 = [];
  @Input() data_source_5: Excedents[] = [];
  @Output('eventInit') fatherOnInit = new EventEmitter();

  smartTableSource: any[] = [];

  constructor(
    private dialogService: MatDialog,
    private planService: PlanService
  ) { }

  ngOnInit() { }

  onCustomAction(event: any) {
    if (event.action === 'toggle') {
      const plan = event.data;
      this.togglePlan(plan);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data_source_5 && this.data_source_5?.length > 0) {
      // Mapear propiedades para que coincidan con settingsExcedents
      this.smartTableSource = this.data_source_5.map(item => ({
        title: "Excedente 1",
        _id: item._id,
        precio: item.excedentPrice,
        time: item.excedentHoursBlock,
        timeCalls: item.excedentMinutesBlock
      }));
    } else {
      this.smartTableSource = [];
    }
  }

  async createPlan() {
    const resultDialog = await this.dialogService.open(AddPlanComponent, { height: '50vh' })
      .beforeClosed().toPromise();
    if (resultDialog) {
      this.fatherOnInit.emit();
    }
  }

  async editPrice(event: any, isExcedent: boolean = false) {
  try {
    const resultDialog = await this.dialogService.open(AddPlanComponent, {
      height: "50vh",
      data: {
        data: event.data,
        type: isExcedent ? 'excedent' : 'plan',
      },
    }).beforeClosed().toPromise();

    if (resultDialog) {
      this.fatherOnInit.emit();
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Ocurrió un error inesperado",
      text: "Si el problema persiste, favor de reportar el error"
    });
  }
}

  async deletePlan(data: any) {
    try {
      const result = await Swal.fire({
        title: "¿Seguro que quiere eliminar este plan?",
        text: "Este plan ya no podrá ser asignado a los clientes.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      });
      if (result.isConfirmed) {
        await this.planService.deletePlan(data._id);
        await Swal.fire({
          position: "center",
          icon: "success",
          title: "Plan eliminado",
          showConfirmButton: false,
          timer: 1000,
        });
        this.fatherOnInit.emit();
      }
    } catch (error) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Ocurrió un error inesperado",
        text: "Si el problema persiste, favor de reportar el error"
      });
    }
  }

  async togglePlan(plan: any) {
      try {

        const newStatus = !plan.active;

        const confirm = await Swal.fire({
          title: newStatus ? "Activar plan" : "Desactivar plan",
          text: newStatus
            ? "El plan estará disponible nuevamente"
            : "El plan no podrá ser asignado a nuevos clientes",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: newStatus ? "Activar" : "Desactivar",
          cancelButtonText: "Cancelar"
        });

        if (!confirm.isConfirmed) return;

        await this.planService.togglePlanStatus(plan._id, newStatus);

        Swal.fire("OK", "Estado actualizado", "success");

        this.fatherOnInit.emit();

      } catch (error) {
        Swal.fire("Error", "No se pudo actualizar", "error");
      }
  }
}
